<div class="example-box-question">
  <div
  class="w-100"
  [ngClass]="question.selectedForRelocation ? 'tile-background-selected' : 'tile-background'"
  style="max-width: 100%; height: 100%;"
>

      <h4 class="headertext-color-list text-center d-flex align-items-center justify-content-center position-relative">
        {{ question.Question_ID }}<span style="font-size: 14px; margin-left: 10px;"> {{printQuestionDetails()}} </span>

        <div class="position-absolute d-flex gap-2 align-items-center" style="right:20px">
          <div *ngIf="relocateQuestions" class="d-flex align-items-center justify-content-center mb-1">
            <div class="form-check">
              <label class="form-check-label me-1 text-white fs-6" [for]="'relocateCheckbox' + index">
                Select to Relocate
              </label>
              <input
                class="form-check-input-sm"
                style="width: 28px; height: 16px;"
                type="checkbox"
                [id]="'relocateCheckbox' + index"
                [(ngModel)]="question.selectedForRelocation"
                (change)="onRelocateChange()"
              >
            </div>
          </div>
          <div *ngIf="preSelectQuestions" class="d-flex align-items-center justify-content-center mb-1">
            <div class="form-check">
              <label class="form-check-label me-1 text-white fs-6" [for]="'PreEvalCheckbox' + index">
                Select to Pre-Evaluate
              </label>
              <input
                class="form-check-input-sm"
                style="width: 28px; height: 16px;"
                type="checkbox"
                [id]="'PreEvalCheckbox' + index"
                [disabled]="!selectedCourse"
                [(ngModel)]="question.selectedForPreEvaluation"
                (change)="onPreEvaluateQuestionChange()"
              >
            </div>
          </div>
          <span class="me-2" *ngIf="question.Display_Order">{{ question.Display_Order }}</span>
          <i class="fa fa-pencil-square-o pointer-cursor" *ngIf="editQuestions" aria-hidden="true" (click)="triggerEdit()"></i>
        </div>

        <span class="position-absolute fs-5" style="left:20px" *ngIf="question.Question_Status_Type_Name">
          {{ question.Question_Status_Type_Name }}
        </span>

        <span class="position-absolute fs-6" style="left:20px; bottom:-338px;" *ngIf="question.Creation_Date">
          Created By: {{ question.Created_By }} ({{ question.Creation_Date | date: 'short' }})
        </span>

        <span class="position-absolute fs-6" style="right:20px; bottom:-338px;" *ngIf="question.Updated_Date">
          Updated By: {{ question.Updated_By }} ({{ question.Updated_Date | date: 'short' }})
        </span>
      </h4>

      <div class="row bg-white mx-4 mt-2 q-container" style="max-height: 300px; min-height: 300px; overflow-y: auto;">
        <div class="col-12 mb-2 question-text-area" style="word-wrap: break-word; text-align: left; padding: 10px; border: 1px solid #ddd; border-radius: 4px; background-color: #f8f9fa;">
          <span class="d-block" [innerHtml]="SanitizeHTML(question.Question_Text ?? '')"></span>
        </div>

        <div class="col-12">
          <div class="row py-1" *ngFor="let answer of question.AllAnswers">
            <div class="col-4 col-md-3 text-end pe-2 AnswerChoicelabel">
              {{ answer?.Right_Answer_Ind === 'Y' ? 'Right Answer' : 'Wrong Answer' }}:
            </div>
            <div class="col-8 col-md-9 AnswerChoicelabel1">
              <div class="d-block" [innerHtml]="SanitizeHTML(answer?.Answer_Choice_Text ?? '')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
